import { stringifyUrl } from 'query-string';
import { getTLSOnlineWrapperApiUrl } from '../selectors/getBaseUrlSelectors';

export default {
  fetch: ({ campaignId, locale, campaignName }, action, state) => ({
    url: stringifyUrl({
      url: `${getTLSOnlineWrapperApiUrl(state)}/v1/${locale}/hotelOffers/${campaignId}`,
      query: {
        campaignName,
      },
      opts: {
        credentials: 'omit',
      },
    }),
  }),
};
